module.exports = __webpack_public_path__ + "3a00c3a59d08f5a4d1b03be473819612.MP3";